module.exports = __webpack_public_path__ + "img/zanwu.d6a83975.png";